// extracted by mini-css-extract-plugin
export var audioPlayer = "_om-0";